/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { DataModel } from '../engine/data-model';
import { IEntity } from '../interface/IEntity';
import { DataTableRow } from '../model/data-table/data-table-row';
import { Selectable } from '../interface/selectable';
import { CheckState } from '../enum/check-state.enum';

/**
 * Class represent Group of Row when table is grouped by column value
 */
export class GroupEntity<T extends IEntity> implements Selectable {
  public get checkState(): CheckState {
    if (this.items) {
      const count = this.items.filter((item) => item.check).length;
      switch (count) {
        case 0:
          return CheckState.uncheck;
        case this.items.length:
          return CheckState.check;
        default:
          return CheckState.partial;
      }
    } else {
      return this.check ? CheckState.check : CheckState.uncheck;
    }
  }

  set checkState(value: CheckState) {
    this._checkState = value;
  }
  get check(): boolean {
    return this._check;
  }

  set check(value: boolean) {
    this.items.forEach((row) => (row.check = value));
  }
  public value: string;
  public open: boolean;
  public total: T;
  readonly model: DataModel;

  private _check: boolean;
  enable: boolean;
  private _checkState: CheckState;
  icon: string;
  iconColor: string;
  items: DataTableRow<T>[];
  normalizedText: string;
  label?: string;
  itemsCount: number;

  public constructor(
    value: string,
    model: DataModel,
    firstItem?: DataTableRow<T>,
    icon?: string
  ) {
    this.value = value;
    this.open = false;
    this.model = model;
    if (firstItem) {
      this.items = [firstItem];
    } else {
      this.items = [];
    }
    this.icon = icon;
  }

  compare(item: any): number {
    if (item) {
      return item.value
        ? this.value.localeCompare(item.value)
        : this.value.localeCompare(item);
    } else {
      return 1;
    }
  }

  public add(row: DataTableRow<T>) {
    this.items.push(row);
  }

  public doCheck() {
    const state = this.checkState;
    this.check = state !== CheckState.check;
  }
}
